import { createContext, useContext, useState } from "react";

const ContactContext = createContext();
export const useContact = () => useContext(ContactContext);

export const ContactProvider = ({ children }) => {
  const [open, setOpen] = useState(false);

  const showContact = () => setOpen(true);
  const hideContact = () =>{ setOpen(false)};
  const toggleContact = () => setOpen(prev => !prev);

  return (
    <ContactContext.Provider value={{ open, showContact, hideContact, toggleContact }}>
      {children}
    </ContactContext.Provider>
  );
};
